import React, { FunctionComponent as FC, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux'; // To call Action Creators
import { bindActionCreators } from 'redux';
import { actionCreators } from '../../../../state';
import { State } from '../../../../state';
import _ from 'lodash';
import * as d3 from  "d3";
import './index.scss';

import logoUrl from '../../../../assets/XRP.svg';
import { ImpactType, CitationFlowType } from '../../../../types/data.global';
import { MainViewTypes } from '../../../../types/data';


// opt 3
// nhb-ftf version
// Import shared configuration to ensure consistent node size scaling
// between bubble treemap and highlighted impact nodes
// // [abandon] method 1: import from `bubbleTreemapConfig.ts`
// import { bubbleTreemapStyle, entityFieldLevelHighlighedImpactNodeStyle } from '../EntityFieldLevelGraph/bubbleTreemapConfig';
// method 2: import from uiReducer > sharedBubbleTreemapStyle, see code below in the component




// vis2024 version
// const bubbleTreemapStyle = {
//   x: svgSize.mainview.width / 2,
//   y: svgSize.mainview.height / 2,
//   radius: 1600,
//   padding: {
//     outerPadding: 6,
//     leafNodePadding: 24,
//   },

//   leafNodeSizeScaleType: 'pow',   // 'pow', 'log', 'linear',
//   powParam: 0.6,
// }
// const entityFieldLevelHighlighedImpactNodeStyle = {
//   leafNodeSizeScaleType: 'pow',   // 'pow', 'log', 'linear',
//   powParam: 1,
//   // powParam: 0.6,
// }



interface EntityFieldLevelHighlighedImpactNodeProps {
  entityFieldGraphData: any;
}

const EntityFieldLevelHighlighedImpactNode: FC<EntityFieldLevelHighlighedImpactNodeProps> = (props) => {

  const {
    entityFieldGraphData,
  } = props

  const dispatch = useDispatch()
  const {
    isShowPredictionFlow,
    isShowHistoricalFlow,
    updateSelectedImpactEntityField,
  } = bindActionCreators(actionCreators, dispatch)

  // // data reducer
  // const leafNodeSizeScaleType: string = entityFieldLevelHighlighedImpactNodeStyle.leafNodeSizeScaleType
  // // const leafNodeSizeScaleType: string = useSelector((state: State) => state.dataReducer?.leafNodeSizeScaleType) as string

  const leafNodeSizeScale_ForHighlightedGrantField: any = useSelector((state: State) => state.dataReducer?.leafNodeSizeScale_ForHighlightedGrantField) as any
  const nodePositionList: MainViewTypes.NodePosition[] = useSelector((state: State) => state.dataReducer?.nodePositionList) as MainViewTypes.NodePosition[]
  const impactType: string = useSelector((state: State) => state.uiReducer?.impactType) as string

  // ui reducer
  // bubbleTreemapStyle, entityFieldLevelHighlighedImpactNodeStyle
  const sharedBubbleTreemapStyle: MainViewTypes.BubbleTreemapStyle = useSelector((state: State) => state.uiReducer?.sharedBubbleTreemapStyle) as MainViewTypes.BubbleTreemapStyle
  const citationFlowType: string = useSelector((state: State) => state.uiReducer?.citationFlowType) as string
  const impactStatisticsTypeList: string[] = useSelector((state: State) => state.uiReducer?.impactStatisticsTypeList) as string[]
  const highlghtedGrantFieldID: string = useSelector((state: State) => state.dataReducer?.highlghtedGrantFieldNode.grantFieldID) as string
  const highlightedGrantFieldData: MainViewTypes.HighlightedGrantFieldData = useSelector((state: State) => state.dataReducer?.highlightedGrantFieldData) as MainViewTypes.HighlightedGrantFieldData



  // console.log('\n\n========== Component: EntityFieldLevel_HighlighedImpactNode (started!) ============')
  // console.log('leafNodeSizeScale_ForHighlightedGrantField: ', leafNodeSizeScale_ForHighlightedGrantField)
  // console.log('leafNodeSizeScale: ', leafNodeSizeScale)

  // pre-process: ui parameters
  const bubbleTreemapStyle = sharedBubbleTreemapStyle;
  const entityFieldLevelHighlighedImpactNodeStyle = {
    leafNodeSizeScaleType: sharedBubbleTreemapStyle.leafNodeSizeScaleType,
    powParam: sharedBubbleTreemapStyle.powParam,
  };
  const leafNodeSizeScaleType: string = entityFieldLevelHighlighedImpactNodeStyle.leafNodeSizeScaleType

  // function for calculation
  // 2. 应用到subset数据
  const applyScaleToSubset = (value: number, scaleFactor: number, scaleType: string) => {
    const transformedValue = getTransformedValue(value, scaleType);
    const theoreticalRadius = Math.sqrt(transformedValue / Math.PI);
    return theoreticalRadius * scaleFactor;
  };
  // 3. 变换函数（唯一的区别）
  const getTransformedValue = (value: number, scaleType: string) => {
    switch (scaleType) {
      case 'pow': return Math.pow(value, bubbleTreemapStyle.powParam);
      case 'linear': return value;
      case 'log': return Math.log(value + 1);
      default: return value;
    }
  };



  // function for interactions
  const handleMouseOnClick = (e: MouseEvent, id: string) => {
    const parts = id.split("-");
    const fieldID: string = parts[2];
    const impactEntity: string = parts[3];

    console.log('highlighted node: ', )
    console.log('id: ', id)
    console.log('click fieldID: ', fieldID, impactEntity)

    // // TODO
    // 根据impact type，决定
    // 1. historical的时候，只更新右下角
    // 2. prediction的时候，只更新PI view信息

    // console.log('citationFlowType: ', citationFlowType)

    if (citationFlowType === CitationFlowType.HISTORICAL) {
      // (1) if historical flow, 接xiaoyu右下角barchart更新
      updateSelectedImpactEntityField({
        [impactEntity]: fieldID,
      })
      isShowPredictionFlow(false)
      isShowHistoricalFlow(true)
      // 以及点击一个impact field node以后，右下角更新chart的接口是state的哪里？
    } else if (citationFlowType === CitationFlowType.PREDICTION) {
      // do nothing, 不存在这种情况

      // // (2) if prediction flow, 高亮prediction result: grantNode + flow高亮 + PI view更新
      // const predictionSearchResult: MainViewTypes.PredictionSearchResult = {
      //   entity: impactEntity, // 'clinical_trial',
      //   fieldIDList: [fieldID], // ['C11.768', 'C23.888'],
      // }
      // updatePredictionSearchResult(predictionSearchResult)
      // isShowPredictionFlow(true) // 从impact entity field出发画flow
      // isShowHistoricalFlow(false) // 从grant_field出发画flow。本质flow是一样的，只是highlight的flow不一样

      // // update PI view
      // const predictedData = predictionData[impactTypeRefined][impactEntity].find((fieldIDData: MainViewTypes.PredictionEntityFieldIDUnit) => fieldIDData.field_id === fieldID)
      // const predictedDataGlobal = predictionDataGlobal[impactTypeRefined][impactEntity].find((fieldIDData: MainViewTypes.PredictionEntityFieldIDUnit) => fieldIDData.field_id === fieldID)
      // if (predictedData) {
      //   updatePredictionGrantIDList4PIView(predictedData.grant_id_list, predictedDataGlobal.grant_id_list)
      // }
      // // 以及点击一个impact field node以后，右下角更新chart的接口是state的哪里？

      // // clear up historical selected (1) citation flow (2) highlight node
      // onClickGrantFieldNode({
      //   grantFieldID: '',
      //   grantFieldName: '',
      // })
    }
  }


  // 5. highlight grant field node's impact nodes
  // // input
  // console.log('highlghtedGrantFieldID: ', highlghtedGrantFieldID)
  // console.log('highlightedGrantFieldData: ', highlightedGrantFieldData)
  // console.log('nodePositionList: ', nodePositionList) // 记录node position (x, y)

  let highlightedGrantField_ImpactNodeList: JSX.Element[] = [];
  if ((highlghtedGrantFieldID !== '') && (nodePositionList.length > 0)) {
    // (1) get position (x, y)
    let highlightedGrantField_ImpactNodeDataList: any[] = []
    _.forEach(highlightedGrantFieldData, (entityTypeData: MainViewTypes.HighlightedGrantFieldDataUnit[], entityType: string) => {
      // console.log('entityType: ', entityType)
      // console.log('entityTypeData: ', entityTypeData)
      // console.log('impactStatisticsTypeList: ', impactStatisticsTypeList)

      if (impactStatisticsTypeList.includes(entityType)) {
        const updatedEntityTypeData = entityTypeData.map(entity => {
          const correspondingNode = nodePositionList.find(node => node.id === entity.node_field_code.toString());
          if (correspondingNode) {
              return {
                  ...entity,
                  x: correspondingNode.x,
                  y: correspondingNode.y,
                  entity: entityType,
              };
          }
          return entity;
        })
        highlightedGrantField_ImpactNodeDataList = highlightedGrantField_ImpactNodeDataList.concat(updatedEntityTypeData)
      }
    })
    // console.log('highlightedGrantField_ImpactNodeDataList: ', highlightedGrantField_ImpactNodeDataList)

    // (2) set JSX Element
    highlightedGrantField_ImpactNodeList = highlightedGrantField_ImpactNodeDataList.map((impactNodeData, index) => {

      // console.log('impactNodeData: ', impactNodeData)
      const value: number = impactNodeData.node_size
      let r: number = 0

      // nhb-ftf version
      r = applyScaleToSubset(value, leafNodeSizeScale_ForHighlightedGrantField, leafNodeSizeScaleType)

      // // [abandon] vis2024 version
      // if (leafNodeSizeScaleType === 'linear') {
      // } else if (leafNodeSizeScaleType === 'pow') {
      //   // nhb-ftf version
      //   // 先用原始公式计算理论半径
      //   const transformedValue = Math.pow(value, entityFieldLevelHighlighedImpactNodeStyle.powParam);
      //   const theoreticalRadius = Math.sqrt(transformedValue / Math.PI);

      //   // 然后应用相同的缩放因子
      //   r = theoreticalRadius * leafNodeSizeScale;

      //   console.log('--------------------------------')
      //   console.log('---- calc leafNodeSizeScale ----')
      //   console.log('--------------------------------')
      //   console.log('value: ', value)
      //   console.log('transformedValue: ', transformedValue)
      //   console.log('theoreticalRadius: ', theoreticalRadius)
      //   console.log('leafNodeSizeScale: ', leafNodeSizeScale)

      //   // vis2024 version
      //   // const powParam = 0.3
      //   // r = Math.sqrt((value^powParam / leafNodeSizeScale))
      //   // // leafNodeSizeScale = (value^powParam) / Math.pow(r, 2)
      // } else if (leafNodeSizeScaleType === 'log') {
      //   // vis2024 version
      //   // r = Math.sqrt((Math.log(value+1) / leafNodeSizeScale))
      //   // // leafNodeSizeScale = (Math.log(value+1)) / Math.pow(r, 2)
      // } else {
      //   console.log('error: leafNodeSizeScaleType!')
      // }
      // // [abandon] vis2024 version
      // // hard code:
      // if (impactNodeData.entity === 'patent') {
      //   r = r / 3
      // } else if (impactNodeData.entity === 'policy') {
      //   r = r / 1.2
      // } else if (impactNodeData.entity === 'clinical_trial') {
      //   r = r / 1
      // }

      return (
        <g key={`highlight-circle-group-r={${r}}-value={${value}}-scale={${leafNodeSizeScale_ForHighlightedGrantField}}-${index}`}
            id={`leaf-node-${impactNodeData.entity}-${impactType}`}
          // id={`highlight-circle-r={${r}-value={${value}}-scale={${leafNodeSizeScale}}}}`}
            onClick={(e) => {
              const id = e.currentTarget.id
              handleMouseOnClick(e as unknown as MouseEvent, id)
            }}
        >
          <circle key={`highlight-circle-r={${r}}-value={${value}}-scale={${leafNodeSizeScale_ForHighlightedGrantField}}-${index}`}
                id={`highlight-circle-r={${r}}-value={${value}}-scale={${leafNodeSizeScale_ForHighlightedGrantField}}-${index}`}
                cx={impactNodeData.x} cy={impactNodeData.y}
                r={r}
                fill="url(#leaf-node-fill)"
                // fill='red'
                opacity={1}
          />
          {/* <circle cx={impactNodeData.x} cy={impactNodeData.y} r={3} fill='blue' opacity={0.5} /> */}
        </g>



        // TODO: bubble treemap leaf node size scale搞一下
        // note: scale是对的。但是感觉数字计算错了。。。check 每一个grant_field对应产生的num_impact_doc计算


      )
    })
  }
  // console.log('========== Component: EntityFieldLevel_HighlighedImpactNode (finished!) ============\n\n')

  return (
    <g id="highlighted-grant-field-impact-node-wrapper">
      {highlightedGrantField_ImpactNodeList}
    </g>
  )
}

export default EntityFieldLevelHighlighedImpactNode;